<template>
    <div class="jump-warphd nav-bar-fixed" v-show="showDiv">
      <!-- 月结账单走的银联支付 -->
        <van-nav-bar title="银联支付" left-arrow fixed 
        @click-left="back" />
        <div class="c-body">
            <p class="c-desc">由于银行单笔交易额限制，订单金额超过20,000.00元请使用对公账户支付(需电脑支付)</p>
            <van-field label="转账金额" type="number" v-model="price"/>
        </div>
        <div class="jump-warphd-foot">
            <van-button  size="large" @click="pay">提 交</van-button>
        </div>
    </div>
</template>
<script>
import { NavBar,Cell, CellGroup, Field, Button, Row, Col,Radio,RadioGroup  } from "vant";
export default {
  name: "orderpay",
  components: {
    [NavBar.name]: NavBar,
    [CellGroup.name]: CellGroup,
    [Cell.name]:Cell,
    [Field.name]: Field,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Radio.name]:Radio,
    [RadioGroup.name]:RadioGroup
  },
  data() {
    return {
        url:'http://wx.jumuc.com/',
        paymentCodes:[],
        id:0,
        money:0,
        orders:'',
        orderId:'',//展示id
        price:0,
        showDiv:true,
        payUrl:"",
        token: localStorage.getItem("token")
    };
  },
   
    mounted(){
    let that = this;
    this.id=this.$route.query.id;
      window.addEventListener('message',function(event){
          let resultData=event.data;
          if(JSON.stringify(resultData).indexOf("op_title")!=-1){
              that.bakcPaySuccess();
          }
      })
    
  },
   beforeDestroy(){
        const oIframe = document.getElementById("payIframe");
        oIframe.style.display ="none";
         document.querySelector('.wrapper').className = 'wrapper';
    },

  methods: {
    back(){
      history.back();
        const oIframe = document.getElementById("payIframe");
        oIframe.style.display ="none";
    },
      bakcPaySuccess:function(){
          location.href = "#/bill/success";
      },
    pay(){
        var that=this;
      
        //that.showDiv=false;
                that.$api.post(that.jumuc.milk.onlinePay,{'bankWaterMoney':this.price,'payType':1,'milkConfirmId':this.id},res => {
                    if(res.success){
                        this.payUrl=this.$api.root+"pay/genericUnionPay?payment_id="+res.data.payment_id+"&type="+res.data.type+"&childPayType="+res.data.childPayType+"&id="+res.data.id+"&money="+this.price+"&url="+this.$api.root+"&token="+this.token;
                              that.showDiv=false;
                              const oIframe = document.getElementById("payIframe");
                              oIframe.src=this.payUrl;
                              oIframe.style.display ="block";
                                document.querySelector('.wrapper').className = 'wrapper no-header';
                    }
                })

    }
  },
  
};
</script>
<style lang="less">
@bule-thame: #3C6EEB;

.jump-warphd {
   .c-body{
       padding: 10px;
        p{
            font-size: 14px;
            line-height: 38px;
        }
        .c-desc{
            line-height: 22px;
        }
        .c-pay{
            padding: 10px 0;
        }
        .van-radio{
            display: inline-block;
            margin-left: 5px;
        }
   }
    &-foot{
      padding: 10px 15px;
      font-size: 14px;
      button {
        background-color: @bule-thame;
        color: white;
        font-weight: 700;
        border-radius: 5px;
        margin: 25px 0 10px;
      }
    }
}
</style>
